module.exports = __webpack_public_path__ + "img/intro1.7a23edab.png";